module.exports = __webpack_public_path__ + "img/column2.e6d22126.png";